export default {
  title: 'Accueil',
  nav: { myAccount: 'Mon espace' },
  hero: {
    eyebrow: 'Rive-Sud et Montréal',
    title: 'Une maison propre, sans y penser.',
    subtitle: 'Ménage résidentiel et commercial par une équipe stable, assurée et attentionnée. Réservez en deux minutes, suivez tout depuis votre téléphone.',
    cta: 'Demander une soumission',
    secondary: 'J’ai déjà un compte',
  },
  services: {
    title: 'Nos services',
    standard: { title: 'Ménage régulier', text: 'Chaque semaine, aux deux semaines ou chaque mois, avec la même équipe.' },
    deep: { title: 'Nettoyage profond', text: 'Joints, plinthes, dessous des meubles : un vrai grand ménage.' },
    move: { title: 'Déménagement', text: 'Logement vide nettoyé de fond en comble, armoires et électroménagers inclus.' },
    commercial: { title: 'Commercial', text: 'Bureaux, cliniques et commerces, en dehors de vos heures d’ouverture.' },
  },
  how: {
    title: 'Comment ça fonctionne',
    s1: { title: 'Décrivez votre propriété', text: 'Nombre de pièces, animaux, préférences : une seule fois.' },
    s2: { title: 'Recevez votre prix', text: 'Notre équipe confirme un prix clair, sans surprise.' },
    s3: { title: 'Acceptez et c’est réglé', text: 'Votre équipe arrive à l’heure, vous suivez tout en ligne.' },
  },
  benefits: {
    title: 'Pourquoi nous choisir',
    b1: 'La même équipe à chaque visite',
    b2: 'Rappel automatique avant chaque ménage',
    b3: 'Modification ou annulation en ligne',
    b4: 'Employés formés, assurés et bien payés',
  },
  estimate: {
    title: 'Estimez votre ménage',
    subtitle: 'Une fourchette indicative. Le prix officiel est confirmé par notre équipe.',
    service: 'Type de ménage',
    propertyType: 'Type de propriété',
    bedrooms: 'Chambres',
    bathrooms: 'Salles de bain',
    floors: 'Étages',
    frequency: 'Fréquence',
    pets: 'Animaux à la maison',
    compute: 'Voir l’estimation',
    result: 'Entre {{low}} et {{high}}',
    duration: 'Durée estimée : {{duration}}',
    book: 'Réserver avec ce prix indicatif',
  },
  footer: { rights: 'Tous droits réservés.', contact: 'Nous joindre' },
  login: {
    title: 'Connexion',
    subtitle: 'Accédez à votre espace.',
    email: 'Courriel',
    password: 'Mot de passe',
    submit: 'Se connecter',
    noAccount: 'Pas encore de compte?',
    demoTitle: 'Comptes de démonstration',
    demoHint: 'Mot de passe : demo1234',
    welcome: 'Bon retour !',
    welcomeText: 'Connectez-vous pour suivre vos ménages.',
    forgot: 'Mot de passe oublié ?',
    or: 'ou',
    createAccount: 'Créer un compte',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    staffHint: 'Employé ou gestionnaire ? Utilisez le même formulaire.',
    sideTitle: 'Une maison plus sereine au quotidien.',
    b1: 'Vos rendez-vous en un coup d’œil',
    b2: 'Modifications en ligne',
    b3: 'Messages avec notre équipe',
    b4: 'Instructions conservées et sécurisées',
  },
  register: {
    title: 'Créer mon compte',
    subtitle: 'Pour réserver et suivre vos ménages.',
    fullName: 'Nom complet',
    phone: 'Téléphone',
    password: 'Mot de passe (8 caractères minimum)',
    submit: 'Créer mon compte',
    hasAccount: 'Déjà un compte?',
    consent: 'J’accepte les <terms>conditions d’utilisation</terms> et la <privacy>politique de confidentialité</privacy>.',
    consentRequired: 'Veuillez accepter les conditions pour créer votre compte.',
    quoteKept: 'Vos réponses à la soumission sont conservées : vous les retrouverez à l’étape suivante.',
  },
  checkout: {
    title: 'Paiement sécurisé (simulation)',
    subtitle: 'Mode local : aucune carte n’est demandée ni enregistrée. Choisissez le résultat à simuler.',
    pay: 'Payer {{amount}}',
    fail: 'Simuler un refus',
    success: 'Paiement reçu. Merci!',
    failed: 'Le paiement a été refusé (simulation).',
    back: 'Retour à mes paiements',
  },
  notFound: { title: 'Page introuvable', text: 'Le lien est peut-être incorrect ou la page a été déplacée.', home: 'Retour à l’accueil' },
};
